// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssr-section-wrapper .paid-ssr-section-wrapper .paid-ssr-items-wrapper .ssr-input-item-wrapper input {
  display: none;
}
.ssr-section-wrapper .paid-ssr-section-wrapper .paid-ssr-items-wrapper .ssr-input-item-wrapper label {
  position: relative;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.ssr-section-wrapper .paid-ssr-section-wrapper .paid-ssr-items-wrapper .ssr-input-item-wrapper label:before {
  content: "";
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #c2c2c2;
  border-radius: 2px;
  padding: 6px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}
.ssr-section-wrapper .paid-ssr-section-wrapper .paid-ssr-items-wrapper .ssr-input-item-wrapper input:checked + label:before {
  border: 1px solid #92278f;
}
.ssr-section-wrapper .paid-ssr-section-wrapper .paid-ssr-items-wrapper .ssr-input-item-wrapper input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 6px;
  left: 4px;
  width: 5px;
  height: 9px;
  border: solid #92278f;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ssr-section-wrapper .remarks-ssr-section-wrapper .remarks-textarea-wrapper label {
  font-size: 16px;
  color: #595C5F;
}
.ssr-section-wrapper .remarks-ssr-section-wrapper .remarks-textarea-wrapper textarea {
  appearance: none;
  border: 1px solid #ddd;
  border-radius: 2px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  padding: 0 4px;
  resize: none;
}
.ssr-section-wrapper .remarks-ssr-section-wrapper .remarks-textarea-wrapper textarea::placeholder {
  color: #aeaeae;
}
.ssr-section-wrapper .remarks-ssr-section-wrapper .remarks-textarea-wrapper textarea:focus-visible {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ViewDetailModal/SsrSection/style.scss"],"names":[],"mappings":"AAIgB;EACI,aAAA;AAHpB;AAMgB;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAJpB;AAOgB;EACI,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AALpB;AAQgB;EACI,yBAAA;AANpB;AASgB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AAPpB;AAcY;EACI,eAAA;EACA,cAAA;AAZhB;AAeY;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AAbhB;AAegB;EACI,cAAA;AAbpB;AAgBgB;EACI,aAAA;AAdpB","sourcesContent":[".ssr-section-wrapper{\n    .paid-ssr-section-wrapper{\n        .paid-ssr-items-wrapper{\n            .ssr-input-item-wrapper{\n                input {\n                    display: none;\n                }\n            \n                label {\n                    position: relative;\n                    cursor: pointer;\n                    font-size: 16px;\n                    font-weight: 700;\n                    letter-spacing: 0.03em;\n                }\n            \n                label:before {\n                    content: '';\n                    appearance: none;\n                    -webkit-appearance: none;\n                    background-color: transparent;\n                    border: 1px solid #c2c2c2;\n                    border-radius: 2px;\n                    padding: 6px;\n                    display: inline-block;\n                    position: relative;\n                    vertical-align: middle;\n                    cursor: pointer;\n                }\n            \n                input:checked+label:before {\n                    border: 1px solid #92278f;\n                }\n            \n                input:checked+label:after {\n                    content: '';\n                    display: block;\n                    position: absolute;\n                    top: 6px;\n                    left: 4px;\n                    width: 5px;\n                    height: 9px;\n                    border: solid #92278f;\n                    border-width: 0 2px 2px 0;\n                    transform: rotate(45deg);\n                }\n            }\n        }\n    }\n    .remarks-ssr-section-wrapper{\n        .remarks-textarea-wrapper {\n            label {\n                font-size: 16px;\n                color: #595C5F;\n            }\n    \n            textarea {\n                appearance: none;\n                border: 1px solid #ddd;\n                border-radius: 2px;\n                font-size: 16px;\n                font-weight: 400;\n                color: #000;\n                padding: 0 4px;\n                resize: none;\n    \n                &::placeholder {\n                    color: #aeaeae;\n                }\n    \n                &:focus-visible{\n                    outline: none;;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
